export default () => {
  if (document.querySelectorAll('.lazyload').length) {
    return import(/* webpackChunkName: "lazysizes" */ 'lazysizes');
  }
  return null;
};
